import dynamic from 'next/dynamic';
import { CartExpiryModalProps } from './CartExpiryModal.types';

export const CartExpiryModal = dynamic<CartExpiryModalProps>(() =>
  import('./CartExpiryModal').then(module => module.CartExpiryModal)
);
